import * as yup from "yup";

const topAgencySchema = yup
  .object()
  .shape({
    bad_behavior_points: yup.number().required(),
    company_id: yup.number().integer().required(),
    company_name: yup.string().required(),
    company_slug: yup.string().required(),
    conversation_outcome_points: yup.number().required(),
    direct_media_reply_points: yup.number().required(),
    disabled_interactions_bad_behavior_points: yup.number().required(),
    hidden: yup.boolean().required(),
    isAlreadyAdded: yup.boolean(),
    num_conversations: yup.number().integer().required(),
    num_direct_media_replies: yup.number().integer().required(),
    num_pitches: yup.number().integer().required(),
    num_profiles: yup.number().integer().required(),
    num_represented: yup.number().integer().required(),
    period_end: yup.string().required(), // ISO date string
    period_slug: yup.string().required(),
    period_start: yup.string().required(), // ISO date string
    pitch_speed_points: yup.number().required(),
    spam_flagged_count_bad_behavior_points: yup.number().required(),
    suspected_leaker_dialog_enabled_count_bad_behavior_points: yup.number().required(),
    tags: yup.array().of(yup.string()),
    total_points: yup.number().required(),
    v1_company_id: yup.number().integer().nullable(),
  })
  .noUnknown();

const topAgenciesSchema = yup.array().of(topAgencySchema);

export default topAgenciesSchema;
